module.exports = __webpack_public_path__ + "static/media/29ADMSPC4.c11f22b4.jpg";